import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '@core/service/auth.service';

@Component({
    template: '',
})
export class LogoutComponent implements OnInit {
    private readonly _authService = inject(AuthService);

    ngOnInit() {
        this._authService.logout(`common.message.logout.successfullyloggedout`, true); // USER_LOGOUT
    }
}
